import type { DynamicActionsConfig } from './types'

const CHAT_APP_DEF_ID = '14517e1a-3ff0-af98-408e-2bd6953c36a2'
const AI_ASSISTANT_DEF_ID = '31ceda3c-e2c8-4e83-816d-ba293597730c'

export const dynamicActionsConfig: DynamicActionsConfig = {
	[CHAT_APP_DEF_ID]: {
		iconSvgContent: `<svg viewBox="17 8 17 17.989" width="50" height="30" xmlns="http://www.w3.org/2000/svg"><g><path d="M19 8c-1.105 0-2 .892-2 2.005v9.577a2 2 0 0 0 1.99 2.004h2.238l-.18 3.847c-.027.555.3.724.736.371L27 21.586h4.994A2.001 2.001 0 0 0 34 19.582v-9.577C34 8.897 33.11 8 32 8H19z" fill-rule="evenodd"/></g></svg>`,
		color: '#2D41A9',
		text: 'Chat',
		itemType: 'chat',
	},
	[AI_ASSISTANT_DEF_ID]: {
		iconSvgContent: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M14.5 0a.5.5 0 0 1 .49.402l.108.539A2.5 2.5 0 0 0 17.06 2.9l.54.109a.5.5 0 0 1 0 .98l-.54.108A2.5 2.5 0 0 0 15.1 6.06l-.109.54a.5.5 0 0 1-.98 0l-.108-.54A2.5 2.5 0 0 0 11.94 4.1l-.54-.109a.5.5 0 0 1 0-.98l.54-.108A2.5 2.5 0 0 0 13.9.94L14.01.4A.5.5 0 0 1 14.5 0ZM7.5 3a.5.5 0 0 1 .482.368L8.43 5.01a6.5 6.5 0 0 0 4.56 4.561l1.642.448a.5.5 0 0 1 0 .964l-1.641.448a6.5 6.5 0 0 0-4.561 4.56l-.448 1.642a.5.5 0 0 1-.964 0L6.57 15.99a6.5 6.5 0 0 0-4.56-4.561l-1.642-.448a.5.5 0 0 1 0-.964L2.01 9.57A6.5 6.5 0 0 0 6.57 5.01l.448-1.642A.5.5 0 0 1 7.5 3Z"/></svg>`,
		color: '#116DFF',
		text: 'AI Chat',
		itemType: 'ai_assistant',
	},
}
